<template>
  <div class="boxCanvas" v-show="showQrCode">
    <div class="canvasBg" @click="closeCode"></div>
    <div class="qrCodeBox">
      <canvas
        ref="qrCanvas"
        class="qrCanvas"
        style="width: 350px; height: 350px"></canvas>
      <div class="qrCodeText">请使用微信扫码支付</div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { getSchoolClass } from "@/api/wkApi";
export default {
  data() {
    return {
      showQrCode: false,
      time: null,
      schoolClassId: null,
    };
  },
  methods: {
    // 生成二维码
    generateQRCode(url, schoolClassId, fnClose) {
      this.schoolClassId = schoolClassId;
      const canvas = this.$refs.qrCanvas;
      QRCode.toCanvas(canvas, url, (error) => {
        if (error) console.error(error);
      });
      this.showQrCode = true;
      if (fnClose) {
        fnClose();
      }
      this.time = setInterval(() => {
        this.getSchoolClass(schoolClassId);
      }, 2000);
    },
    async closeCode() {
      clearInterval(this.time);
      let res = await getSchoolClass();
      let data = res.result.records.find((item) => item.schoolClassId == this.schoolClassId);
      if (data.isJoin == 1) {
        this.$emit("show", "购买成功");
        this.$message.success("购买成功!");
        window.location.reload();
        // 移除购物车
        // try {
        //   let cratList = JSON.parse(localStorage.getItem("cratList")) || [];
        //   let index = cratList.findIndex((item) => item.id == id);
        //   cratList.splice(index, 1);
        //   localStorage.setItem("cratList", JSON.stringify(cratList));
        // } catch {}
      } else {
        this.$emit("close", "关闭成功");
        this.$message.warning("取消购买!");
      }
      this.showQrCode = false;
    },

    async getSchoolClass(schoolClassId) {
      let res = await getSchoolClass();
      let data = res.result.records.find((item) => item.schoolClassId == schoolClassId);
      if (data.isJoin == 1) {
        this.$emit("show", "购买成功");
        clearInterval(this.time);
        window.location.reload();
        // 移除购物车
        // try {
        //   let cratList = JSON.parse(localStorage.getItem("cratList")) || [];
        //   let index = cratList.findIndex((item) => item.id == id);
        //   cratList.splice(index, 1);
        //   localStorage.setItem("cratList", JSON.stringify(cratList));
        // } catch {}
        this.showQrCode = false;
        this.$message.success("购买成功!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.boxCanvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10240;
  .canvasBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .qrCodeBox {
    position: absolute;
    background: #fff;
    width: 400px;
    height: 450px;
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
